import { render, staticRenderFns } from "./CurriculumListPage.vue?vue&type=template&id=558e26d0&scoped=true"
import script from "./CurriculumListPage.vue?vue&type=script&lang=js"
export * from "./CurriculumListPage.vue?vue&type=script&lang=js"
import style0 from "./CurriculumListPage.vue?vue&type=style&index=0&id=558e26d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e26d0",
  null
  
)

export default component.exports